module.exports = {
	extends: [
		'/',
		'base',
		'tabStrip',
		'tab'
	]
}